import { useState, useRef, useEffect } from "react";
import api from "../../services/api";

/**
 * Autocompletado de contactos (nombre, teléfono, email…).
 * onSeleccionar(contacto) al elegir fila; onBlurText(texto) al salir sin elegir (opcional).
 */
export default function BuscadorContacto({
  onSeleccionar,
  isDark,
  placeholder,
  tipo,
  initialValue = "",
  autoFocus = false,
  compact = false,
  onBlurText,
  onTextChange,
  onCancel,
  style,
}) {
  const [texto, setTexto] = useState(initialValue);
  const [resultados, setResultados] = useState([]);
  const [abierto, setAbierto] = useState(false);
  const timerRef = useRef(null);
  const selectingRef = useRef(false);

  useEffect(() => {
    setTexto(initialValue);
  }, [initialValue]);

  const buscar = (q) => {
    setTexto(q);
    onTextChange?.(q);
    clearTimeout(timerRef.current);
    if (q.length < 2) {
      setResultados([]);
      setAbierto(false);
      return;
    }
    timerRef.current = setTimeout(async () => {
      try {
        const tipoQ = tipo ? `&tipo=${encodeURIComponent(tipo)}` : "";
        const r = await api.get(`/contactos/buscar?q=${encodeURIComponent(q)}${tipoQ}`);
        setResultados(r.data.data || []);
        setAbierto(true);
      } catch {
        setResultados([]);
      }
    }, 300);
  };

  const seleccionar = (c) => {
    selectingRef.current = true;
    onSeleccionar(c);
    setTexto("");
    onTextChange?.("");
    setResultados([]);
    setAbierto(false);
  };

  const inputSt = {
    padding: compact ? "3px 6px" : "6px 10px",
    borderRadius: compact ? 6 : 8,
    fontSize: compact ? 12 : 13,
    background: isDark ? "#1f2937" : "#fff",
    border: `1px solid ${isDark ? "#374151" : "#d1d5db"}`,
    color: isDark ? "#f9fafb" : "#111827",
    outline: "none",
    fontFamily: "inherit",
    flex: 1,
    minWidth: compact ? 120 : 200,
    width: "100%",
    ...style,
  };

  const handleBlur = () => {
    setTimeout(() => {
      setAbierto(false);
      if (!selectingRef.current && onBlurText) onBlurText(texto);
      selectingRef.current = false;
    }, 150);
  };

  return (
    <div style={{ position: "relative", flex: 1, minWidth: compact ? 120 : 200, width: "100%" }}>
      <input
        value={texto}
        onChange={(e) => buscar(e.target.value)}
        placeholder={placeholder || "Buscar contacto existente..."}
        style={inputSt}
        autoFocus={autoFocus}
        onBlur={handleBlur}
        onFocus={() => texto.length >= 2 && resultados.length > 0 && setAbierto(true)}
        onKeyDown={(e) => {
          if (e.key === "Escape") {
            e.stopPropagation();
            if (onCancel) onCancel();
            else if (onBlurText) onBlurText(initialValue);
          }
          if (e.key === "Enter" && onBlurText) {
            e.preventDefault();
            onBlurText(texto);
          }
        }}
      />
      {abierto && resultados.length > 0 && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            zIndex: 200,
            background: isDark ? "#1e2330" : "#fff",
            border: `1px solid ${isDark ? "#374151" : "#d1d5db"}`,
            borderRadius: 8,
            boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
            maxHeight: 220,
            overflowY: "auto",
            marginTop: 4,
            minWidth: 220,
          }}
        >
          {resultados.map((c) => (
            <div
              key={c.id}
              onMouseDown={() => seleccionar(c)}
              style={{
                padding: compact ? "7px 10px" : "9px 14px",
                cursor: "pointer",
                borderBottom: `1px solid ${isDark ? "#374151" : "#f3f4f6"}`,
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = isDark ? "#374151" : "#eff6ff";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "transparent";
              }}
            >
              <div style={{ fontSize: compact ? 12 : 13, fontWeight: 600, color: isDark ? "#f3f4f6" : "#111827" }}>
                {c.nombre} {c.apellidos || ""}
              </div>
              <div style={{ fontSize: 11, color: isDark ? "#9ca3af" : "#6b7280", marginTop: 2 }}>
                {[c.telefono, c.email].filter(Boolean).join(" · ") || "Sin datos de contacto"}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}